import Skeleton from './skeleton';

export { Skeleton };

export default Skeleton;
